import {
  ACCOUNTS_KEY,
  COMPANY_STRUCTURE_KEY,
  OWNERS_KEY,
  ASSUMPTION_KEY,
  SCHEDULES_KEY,
  START_KEY,
  TEMPLATES_KEY,
  WORKFORCE_KEY,
} from "features/budget/budget.constants";

const steps = [
  {
    key: START_KEY,
    caption: "Start",
    tooltip:
      "Here you will define the calendar and scenario name. Also you can start based on a previously made one.",
    idbKey: "formValues",
  },
  {
    key: ACCOUNTS_KEY,
    caption: "Accounts",
    tooltip:
      "You'll have to select an account collection to work on your budget. This will define the rows on your template.",
    idbKey: "rowDef",
  },
  {
    key: COMPANY_STRUCTURE_KEY,
    caption: "Company Structure",
    tooltip:
      "Your budget's structure organizes your budgeted accounts and automatically defines the approval chains.",
    idbKey: "companyStructure",
  },
  {
    key: ASSUMPTION_KEY,
    caption: "Assumptions",
    tooltip: "Your assumptions",
    idbKey: "assumption",
  },
  {
    key: SCHEDULES_KEY,
    caption: "Schedules",
    tooltip:
      "Create schedules to assign different units from your company structure",
    idbKey: "scheduleAssignments",
  },
  {
    key: TEMPLATES_KEY,
    caption: "Templates",
    tooltip:
      "Here you can create specific templates-list for different groups from the company structure.",
    idbKey: "templateAssignments",
  },
  {
    key: WORKFORCE_KEY,
    caption: "Workforce",
    tooltip: "Template Workforce allocation",
    idbKey: "workforceAssignments",
  },
  {
    key: OWNERS_KEY,
    caption: "Owners",
    tooltip:
      "Here you can select which owner will be on charge of a specific node or peer from the company structure.",
    idbKey: "ownersAssignments",
  },
];

export default steps;
